module.exports = __webpack_public_path__ + "static/media/thegrguide-IG-2.026c6b89.PNG";